import FeatureLayer from "@arcgis/core/layers/FeatureLayer";

export const cddHist = new FeatureLayer({
    url: "https://njmaps1.rad.rutgers.edu/arcgis/rest/services/Climate/ZZ_CoolingDegreeDays/MapServer/12",
    title: 'Cooling Degree Days Historical',
    opacity: 0.4,
    oraId: 'cddHist',
  })